import React, { useEffect, useState } from "react";
import "./ToastStyle.css";

import success from "../../assets/svg/toastSuccess.svg";
import error from "../../assets/svg/toastError.svg";
import close from "../../assets/svg/close.svg";

const Toast = ({ isSuccess, text, show }) => {
  return (
    <div className={`toastWrap ${isSuccess ? "success" : "error"}`}>
      <div className="toastBox">
        {isSuccess ? <img src={success} /> : <img src={error} />}
        <div className="toastText">{text}</div>

        <span className="closeBtn">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.86507 0.864603C1.03385 0.695879 1.26272 0.601095 1.50137 0.601095C1.74002 0.601095 1.9689 0.695879 2.13767 0.864603L6.00137 4.7283L9.86507 0.864603C9.94809 0.778644 10.0474 0.71008 10.1572 0.662912C10.267 0.615744 10.3851 0.590916 10.5046 0.589878C10.6241 0.588839 10.7426 0.611611 10.8532 0.656863C10.9638 0.702116 11.0643 0.768944 11.1488 0.853447C11.2333 0.937951 11.3002 1.03844 11.3454 1.14904C11.3907 1.25965 11.4134 1.37816 11.4124 1.49766C11.4114 1.61717 11.3865 1.73526 11.3394 1.84507C11.2922 1.95487 11.2236 2.05418 11.1377 2.1372L7.27397 6.0009L11.1377 9.8646C11.3016 10.0343 11.3923 10.2617 11.3903 10.4977C11.3882 10.7336 11.2936 10.9594 11.1267 11.1262C10.9598 11.2931 10.7341 11.3878 10.4981 11.3898C10.2622 11.3919 10.0348 11.3011 9.86507 11.1372L6.00137 7.2735L2.13767 11.1372C1.96793 11.3011 1.74059 11.3919 1.50461 11.3898C1.26863 11.3878 1.0429 11.2931 0.876034 11.1262C0.709166 10.9594 0.614514 10.7336 0.612463 10.4977C0.610413 10.2617 0.701128 10.0343 0.86507 9.8646L4.72877 6.0009L0.86507 2.1372C0.696346 1.96843 0.601562 1.73955 0.601562 1.5009C0.601562 1.26226 0.696346 1.03338 0.86507 0.864603Z"
              fill="#0E9F6E"
            />
          </svg>
        </span>
      </div>
    </div>
  );
};

export default Toast;
